// extracted by mini-css-extract-plugin
export default {"unauthenticatedView":"KnowledgeDetails_unauthenticatedView__Q6a7d","headerContainer":"KnowledgeDetails_headerContainer__Z-VKx","layoutItem":"KnowledgeDetails_layoutItem__99Nsa"};